const LIVE = 'live'
const SESSIONS = `${LIVE}/sessions`
const SESSION = `${SESSIONS}/{0}`
const SESSION_DATA = `${LIVE}/sessionData/{0}`
const WAITING_USERS = `${LIVE}/waitingUsers`
const WAITING_USER = `${WAITING_USERS}/{0}`
const INVITATIONS = `${SESSION_DATA}/invitations`
const INVITATION = `${INVITATIONS}/{1}`
const ROOMS = `${LIVE}/rooms`
const ROOM = `${ROOMS}/{0}`
const ROOM_USERS = `${ROOMS}/{0}/users`
const ROOM_USER = `${ROOM_USERS}/{1}`
const ROOM_DATA = `${LIVE}/roomData/{0}`
const CHAT_ROOM = `${ROOM_DATA}/chat`
const CHAT_ROOM_MESSAGE = `${CHAT_ROOM}/{1}`
const WEBRTC_ROOM = `${ROOM_DATA}/webRtc`
const WEBRTC_ROOM_USER = `${WEBRTC_ROOM}/{1}`
const WEBRTC_ROOM_USER_MESSAGE = `${WEBRTC_ROOM_USER}/{2}`

module.exports.LIVE = LIVE
module.exports.SESSIONS = SESSIONS
module.exports.SESSION = SESSION
module.exports.SESSION_DATA = SESSION_DATA
module.exports.WAITING_USERS = WAITING_USERS
module.exports.WAITING_USER = WAITING_USER
module.exports.INVITATIONS = INVITATIONS
module.exports.INVITATION = INVITATION
module.exports.ROOMS = ROOMS
module.exports.ROOM = ROOM
module.exports.ROOM_USERS = ROOM_USERS
module.exports.ROOM_USER = ROOM_USER
module.exports.ROOM_DATA = ROOM_DATA
module.exports.CHAT_ROOM = CHAT_ROOM
module.exports.CHAT_ROOM_MESSAGE = CHAT_ROOM_MESSAGE
module.exports.WEBRTC_ROOM = WEBRTC_ROOM
module.exports.WEBRTC_ROOM_USER = WEBRTC_ROOM_USER
module.exports.WEBRTC_ROOM_USER_MESSAGE = WEBRTC_ROOM_USER_MESSAGE



// WEBPACK FOOTER //
// ./src/database.js